import { render, staticRenderFns } from "./MassUpdateCourses.vue?vue&type=template&id=e075bb64&scoped=true&"
import script from "./MassUpdateCourses.vue?vue&type=script&lang=js&"
export * from "./MassUpdateCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e075bb64",
  null
  
)

export default component.exports